export default __webpack_public_path__ + "static/0189-c7f55e57a02452df749774fc4eea0321.png";